<template>
  <div>
    <el-row>
      <CoreTableContainer
        CustomTableArticle
        :columns="containerTableColumns"
        :serverUrl="containerServerUrl"
        :baseUrl="containerBaseUrl"        
        :tableToolConfig="tableToolConfig"
        ref="TableContainer"
      >
        <!-- <template v-slot:tools>
          <router-link :to="containerBaseUrl + '/add'">
            <el-button type="primary" icon="el-icon-circle-plus-outline">增加学时信息</el-button>
          </router-link>
        </template>-->

        <template v-slot:filter>
          <UnitCascader v-if="isAdmin" @onValueChanged="onUnitValueChanged"></UnitCascader>
          <PartyOrgCascader v-if="isAdmin" @onValueChanged="onPartyOrgValueChanged"></PartyOrgCascader>
          <!-- <StudyClassSelect @onValueChanged="onStudyClassValueChanged"></StudyClassSelect>
          <PartyOrgSelect  :isStudyclassHours="true" :size="'small'" @onValueChanged="onPartyOrgValueChanged"></PartyOrgSelect>
          <ClassUnitSelect :isStudyclassHours="true" :size="'small'" @onValueChanged="onClassUnitValueChanged"></ClassUnitSelect> -->
        </template>

        <template v-slot:columnSlotTool="{props}">
          <el-button type="warning" size="mini" plain @click="goConfigPage(props)">查看详细</el-button>          
        </template>

        <!--  -->
        <template v-slot:table__footer__info>学时信息列表</template>
      </CoreTableContainer>

      <!-- <el-row>
          <p class="paragraph-content-small grey asset"><i class="el-icon-info"></i> 当前列表项的显示顺序，即是网站相关项目的显示顺序。</p>
      </el-row>-->
    </el-row>
  </div>
</template>

<script>
import { CoreTableContainer } from "@/core/table/";
import { StudyClassSelect,UnitCascader,PartyOrgCascader } from "@/views/components/select";
import { PartyOrgSelect } from "@/views/module/partyOrganization/components";
import { ClassUnitSelect } from "@/views/module/classunit/components";


export default {

  name : 'scheduling-hours',

  components:{
    CoreTableContainer,UnitCascader,PartyOrgCascader,
    StudyClassSelect,
    PartyOrgSelect,
    ClassUnitSelect,
  },

  data(){
    return {
      containerTableColumns : [
        {
          prop: "displayDate",
          label: "排课时间",
        },
        {
          prop: "addresses",
          label: "排课地址",
        },
        {
          prop: "cuser",
          label: "开课人",
          width : "100"
        },
        {
          prop: "createOrg",
          label: "开班单位/党组织",
          width : "400"

        },
      ],
      containerBaseUrl : "/export/schedulingHours",
      containerServerUrl : "/api/manager/report/scheduling",
      tableToolConfig :  {
        canEdit: false,
        canRecover: false,
        canDelete: false,
        canDisable: false,
      }


    }
  },
  methods:{
    goConfigPage(e){
      this.$router.push({
        path:'/export/classPlanDetail',
        query:{
          id:e
        }
      })
    },

    onUnitValueChanged(ids){
      this.$refs.TableContainer.updateParams("units",ids);
    },

    onPartyOrgValueChanged(ids){
      this.$refs.TableContainer.updateParams("partyids",ids);
    }
  },
  computed: {
      isAdmin(){
        return this.$store.getters["profileModule/isadmin"];
      },
  }

}
</script>

<style scoped>
</style>